import { Button, Modal, Space, Steps, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
// import SearchFilter from "./searchFilter";
// import PODetails from "./poDetails";
import { fetchBids } from "../../../../api/bid.api";
import { fetchOrganisationDetails } from "../../../../api/organisation.api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { bidCreationAndEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import { getTableHeight } from "../../../../utils/TableHelpers/TableHeightHelper";
import ColumnConfig from "../Budget/column-config";
import "../stylesManipulated.css";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const Biddings = (props) => {
  const location = useLocation();
  const { Step } = Steps;
  const history = useNavigate();
  const { user } = props.settings;
  const [loading, setLoading] = useState(false);
  const [organisationDetails, setOrganisationDetails] = useState(null);
  const [modal1Visible, setModal1Visible] = useState(false);
  const [bids, setBids] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [poDetails, setPoDetails] = useState(null);

  const logger = useContext(LoggerContext);

  //   const fetchTaxOptions = () => {
  //     axios.get(`${TaxOptionAPI}`).then((res) => {
  //       setTaxOptions(
  //         res.data?.filter(
  //           (each) =>
  //             each.organisation === user?.organisation?.organisation_id
  //         )
  //       );
  //     });
  //   };
  //   const fetchPos = (params = {}) => {
  //     const {
  //       settings: { project },
  //     } = props;
  //     setLoading(true);
  //     axios
  //       .get(`${PoWoApi}`, { params: { ...params } })
  //       .then((res) => {
  //         setPoList(res.data);
  //         setLoading(false);
  //       })
  //       .catch(() => {
  //         toast.error("Something went wrong!");
  //       });
  //   };
  const getOrganisationDetails = () => {
    fetchOrganisationDetails()
      .then((res) => {
        setOrganisationDetails(res);
      })
      .catch(() => {});
  };

  const fetchBidsOfProjects = (params = {}) => {
    setLoading(true);
    fetchBids({ params }).then((res) => {
      setBids(res);
      setLoading(false);
    });
  };
  //   const onEdit = (id) => {
  //     history(`/app/project/powo/edit/` + id, {
  //       state: { editId: id },
  //     });
  //   };
  //   const onDelete = (id) => {
  //     const formData = new FormData();
  //     formData.append("is_deleted", true);
  //     axios
  //       .put(`${PoWoApi}${id}/`, formData)
  //       .then((res) => {
  //         toast.success("Successfully deleted PO!");
  //         fetchPos({ is_deleted: false });
  //       })
  //       .catch(() => {
  //         toast.error("Something went wrong!");
  //       });
  //   };

  useEffect(() => {
    logger.log(LogEvents.projectBiddings, {});
    fetchBidsOfProjects({ project: props.settings?.project?.id });
    // fetchTaxOptions();
    // fetchOrganisationDetails();
    getOrganisationDetails();
  }, []);

  const columns = [
    {
      title: "Bid Package Number",
      key: "bid_number",
      dataIndex: "bid_number",
    },
    {
      title: "Total vendors",
      key: "vendor.id",
      render: (data) => <Space>{data?.vendor?.length ?? 0}</Space>,
    },
    {
      title: "Deadline of Bid",
      key: "bid_due_date",
      dataIndex: "bid_due_date",
    },
    {
      title: "Delivery date",
      key: "desired_delivery_date",
      dataIndex: "desired_delivery_date",
    },
    {
      title: "Actions",
      key: "action",
      render: (data) => (
        <Space>
          <Tag
            onClick={() => {
              logger.log(LogEvents.seeBidDetails, {});
              history(`/app/project/biddings/biddetails/${data?.id}`);
            }}
            style={{ cursor: "pointer" }}
            color={"blue"}
          >
            See Details
          </Tag>
        </Space>
      ),
    },
  ];

  const [userSelectedColumns, setUserSelectedColumns] = useState(columns);

  const getUserSelectedColumns = () => {
    return userSelectedColumns
      .filter((column) => {
        return column?.selected !== false;
      })
      .map((column) => {
        return columns.find((col) => {
          return col.key === column.key;
        });
      })
      .filter((col) => Boolean(col));
  };

  useEffect(() => {
    if (props.settings?.user?.user_selected_columns?.bidding_table) {
      const columnSettings = userSelectedColumns?.map((col) => {
        let currentCol =
          props.settings?.user?.user_selected_columns?.bidding_table?.find(
            (column) => col.key == column?.key
          );
        return { ...col, selected: currentCol?.selected ?? true };
      });
      setUserSelectedColumns(columnSettings);
    }
  }, [props.settings?.user?.user_selected_columns?.bidding_table]);

  useEffect(() => {}, [userSelectedColumns]);
  return (
    <>
      <div>
        <Card>
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="">
                <H5>All Bids</H5>
              </div>
              <Space>
                {bidCreationAndEditGranted(props.settings?.user) && (
                  <Button
                    className="btn btn-primary d-flex align-items-center justify-content-center text-white"
                    onClick={() => {
                      history(`/app/project/biddings/new`, {
                        state: { editId: null },
                      });
                      logger.log(LogEvents.bidInitiate);
                    }}
                  >
                    {" "}
                    <PlusCircle />
                    <div
                      style={{
                        marginLeft: "4px",
                        paddingTop: "4px",
                        paddingBottom: "4px",
                      }}
                    >
                      Create New Bid
                    </div>
                  </Button>
                )}

                {/* <Button
                  className="btn btn-primary d-flex align-items-center justify-content-center text-white"
                  onClick={() => {
                    setModal1Visible(true);
                  }}
                >
                  {" "}
                  <PlusCircle />
                  <div
                    style={{
                      marginLeft: "4px",
                      paddingTop: "4px",
                      paddingBottom: "4px",
                    }}
                  >
                    Send Assessment
                  </div>
                </Button> */}
                <ColumnConfig
                  columns={userSelectedColumns}
                  setCols={(cols) => setUserSelectedColumns(cols)}
                  mode="bidding"
                  onClick={() => {
                    logger.log(LogEvents.customizeBidMenu, {});
                  }}
                />
              </Space>
            </div>
            <div className="my-2">
              <Table
                loading={loading}
                dataSource={bids}
                columns={getUserSelectedColumns()}
                pagination={false}
                scroll={{
                  x: "100%",
                  y: getTableHeight({ table_name: "bidding_table" }),
                }}
              />
            </div>
          </CardBody>
        </Card>
      </div>
      <Modal
        title="Send Assessment"
        centered
        visible={modal1Visible}
        onCancel={() => {
          setModal1Visible(false);
        }}
        width={700}
        footer={[
          // <Button
          //   key="submit"
          //   className="btn btn-primary text-white"
          //   htmlType="submit"
          //   loading={loading}
          //   form="stepForm"
          //   onClick={() => {
          //     addStep();
          //   }}
          // >
          //   Submit
          // </Button>,
          <Button
            key="back"
            onClick={() => {
              setModal1Visible(false);
            }}
          >
            Close
          </Button>,
        ]}
      ></Modal>
    </>
  );
};

export default connect(mapStateToProps)(Biddings);
